export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-ink-950 py-12">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
          <div className="flex items-center gap-3">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-rose-500 to-violet-600 font-black text-white">
              R
            </span>
            <div>
              <p className="font-semibold text-white">The One Research</p>
              <p className="text-xs text-slate-500">A product of The One Stack</p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-6 text-sm text-slate-400">
            <a href="#channels" className="hover:text-white transition">Channels</a>
            <a href="#how" className="hover:text-white transition">How it works</a>
            <a href="#use-cases" className="hover:text-white transition">Use cases</a>
            <a href="#pricing" className="hover:text-white transition">Pricing</a>
            <a href="/privacy" className="hover:text-white transition">Privacy</a>
            <a href="/terms" className="hover:text-white transition">Terms</a>
            <a href="https://theonestack.com" className="hover:text-white transition">The One Stack</a>
            <a href="https://app.theonestack.com/research" className="hover:text-white transition">Sign in</a>
          </div>
        </div>
        <div className="mt-8 border-t border-white/5 pt-8 text-center text-xs text-slate-600">
          <p>© {new Date().getFullYear()} The One Stack. All rights reserved.</p>
          <p className="mt-1">
            Research data is provided on a best-effort basis from public sources. You are
            responsible for verifying any data used in compliance, billing, or regulatory contexts.
          </p>
        </div>
      </div>
    </footer>
  );
}
